import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { ArrowLeft, Mail } from 'lucide-react';
import "../../../assets/css/Admin/AdminAuth/Adminforgotpassword.css";
import forgot from "../../../assets/images/forgot.png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const AdminForgotPassword = () => {
  const { baseUrl } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("user_type", "admin");

    axios
      .post(`${baseUrl}/general/forgotpassword/sendOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          navigate('/admin-otp-verification', { state: { email } });
        } else {
          alert(response.data.message || "Email not found");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  const handleBack = () => {
    navigate('/admin-login');
  };

  return (
    <div className="AdminForgotPassword-wrapper">
      <Container fluid className="AdminForgotPassword-container">
        <Row>
          <Col xs={12}>
            <Button
              variant="light"
              onClick={handleBack}
              className="AdminForgotPassword-back-btn"
            >
              <ArrowLeft size={20} />
            </Button>

            <div className="AdminForgotPassword-image-container">
              <div className="AdminForgotPassword-image-box">
                <img
                  src={forgot}
                  alt="Forgot Password"
                  className="AdminForgotPassword-image"
                />
              </div>
            </div>

            <div className="AdminForgotPassword-content">
              <h2 className="AdminForgotPassword-title">
                Forgot Your Password?
              </h2>
              <p className="AdminForgotPassword-subtitle">
                Enter your email, and we'll send reset instructions.
              </p>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label className="AdminForgotPassword-label">
                    Email
                  </Form.Label>
                  <div className="AdminForgotPassword-input-wrapper">
                    <Mail size={18} className="AdminForgotPassword-input-icon" />
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="AdminForgotPassword-input"
                    />
                  </div>
                </Form.Group>

                <div className="AdminForgotPassword-button-container">
                  <Button
                    type="submit"
                    className="AdminForgotPassword-submit-btn w-100"
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner as="span" animation="border" size="sm" role="status" />
                    ) : (
                      "Send"
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminForgotPassword;